// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_TOq","cls2":"RelatedPapers-cls2_Dq6 RelatedPapers-cls1_TOq"};